module.exports = __webpack_public_path__ + "static/media/DINNextLTProMedium.aafd9b2a.woff";